import { COMPANY_FILTER_CHANGE } from '../../../PartnerOptions/constants'
import { DATE_FILTER_CHANGE, SCANBACK_CHANGE } from '../constants'

import { INSIGHT_WIDGET_REQUEST_ASYNC } from './constants'

const initialState = {
  data: [],
  loader: false,
  error: null,
}
export default (state = initialState, action) => {
  switch (action.type) {
    case INSIGHT_WIDGET_REQUEST_ASYNC.INITIATE:
    case DATE_FILTER_CHANGE:
    case SCANBACK_CHANGE:
    case COMPANY_FILTER_CHANGE:
      return { ...state, loader: true }
    case INSIGHT_WIDGET_REQUEST_ASYNC.SUCCESS:
      return {
        ...state,
        data: {
          ...action.payload,
          spamDiff: action.payload.spamDetected - action.payload.spamPrevious,
          phishDiff: action.payload.phishDetected - action.payload.phishingPrevious,
          spamPercent:
            Math.abs(1 - action.payload.spamDetected / action.payload.spamPrevious) * 100 || 0,
          phishPercent:
            Math.abs(1 - action.payload.phishDetected / action.payload.phishingPrevious) * 100 || 0,
        },
        error: null,
        loader: false,
      }
    case INSIGHT_WIDGET_REQUEST_ASYNC.ERROR:
      return { ...state, loader: false, error: action.error }
    case INSIGHT_WIDGET_REQUEST_ASYNC.CANCEL:
      return { ...state, loader: false }
    default:
      return state
  }
}
